export const CONSTANTS = {
  ru: {
    breadcrumbs: ['Спасибо за заказ!']
  },
  uk: {
    breadcrumbs: ['Дякуємо за замовлення!']
  },
};